/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AccountControllerDtoAccountInventoryInfoAccountInventoryCar from './AccountControllerDtoAccountInventoryInfoAccountInventoryCar';
import AccountControllerDtoAccountInventoryInfoAccountInventoryCarBox from './AccountControllerDtoAccountInventoryInfoAccountInventoryCarBox';
import AccountControllerDtoAccountInventoryInfoAccountInventoryGears from './AccountControllerDtoAccountInventoryInfoAccountInventoryGears';
import AccountControllerDtoAccountInventoryInfoAccountInventoryItems from './AccountControllerDtoAccountInventoryInfoAccountInventoryItems';
import AccountControllerDtoAccountInventoryInfoAccountInventorySpecialBox from './AccountControllerDtoAccountInventoryInfoAccountInventorySpecialBox';
import AccountControllerDtoAccountInventoryInfoAccountInventoryWallet from './AccountControllerDtoAccountInventoryInfoAccountInventoryWallet';
import MaterialProperty from './MaterialProperty';

/**
 * The AccountControllerDtoAccountInventoryInfoResponse model module.
 * @module model/AccountControllerDtoAccountInventoryInfoResponse
 * @version 1.0
 */
class AccountControllerDtoAccountInventoryInfoResponse {
    /**
     * Constructs a new <code>AccountControllerDtoAccountInventoryInfoResponse</code>.
     * @alias module:model/AccountControllerDtoAccountInventoryInfoResponse
     */
    constructor() { 
        
        AccountControllerDtoAccountInventoryInfoResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AccountControllerDtoAccountInventoryInfoResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AccountControllerDtoAccountInventoryInfoResponse} obj Optional instance to populate.
     * @return {module:model/AccountControllerDtoAccountInventoryInfoResponse} The populated <code>AccountControllerDtoAccountInventoryInfoResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AccountControllerDtoAccountInventoryInfoResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('wallet')) {
                obj['wallet'] = AccountControllerDtoAccountInventoryInfoAccountInventoryWallet.constructFromObject(data['wallet']);
            }
            if (data.hasOwnProperty('specialBox')) {
                obj['specialBox'] = ApiClient.convertToType(data['specialBox'], [AccountControllerDtoAccountInventoryInfoAccountInventorySpecialBox]);
            }
            if (data.hasOwnProperty('car')) {
                obj['car'] = ApiClient.convertToType(data['car'], [AccountControllerDtoAccountInventoryInfoAccountInventoryCar]);
            }
            if (data.hasOwnProperty('carBox')) {
                obj['carBox'] = ApiClient.convertToType(data['carBox'], [AccountControllerDtoAccountInventoryInfoAccountInventoryCarBox]);
            }
            if (data.hasOwnProperty('items')) {
                obj['items'] = ApiClient.convertToType(data['items'], [AccountControllerDtoAccountInventoryInfoAccountInventoryItems]);
            }
            if (data.hasOwnProperty('gears')) {
                obj['gears'] = ApiClient.convertToType(data['gears'], [AccountControllerDtoAccountInventoryInfoAccountInventoryGears]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AccountControllerDtoAccountInventoryInfoResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AccountControllerDtoAccountInventoryInfoResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }
        // validate the optional field `wallet`
        if (data['wallet']) { // data not null
          AccountControllerDtoAccountInventoryInfoAccountInventoryWallet.validateJSON(data['wallet']);
        }
        if (data['specialBox']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['specialBox'])) {
                throw new Error("Expected the field `specialBox` to be an array in the JSON data but got " + data['specialBox']);
            }
            // validate the optional field `specialBox` (array)
            for (const item of data['specialBox']) {
                AccountControllerDtoAccountInventoryInfoAccountInventorySpecialBox.validateJSON(item);
            };
        }
        if (data['car']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['car'])) {
                throw new Error("Expected the field `car` to be an array in the JSON data but got " + data['car']);
            }
            // validate the optional field `car` (array)
            for (const item of data['car']) {
                AccountControllerDtoAccountInventoryInfoAccountInventoryCar.validateJSON(item);
            };
        }
        if (data['carBox']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['carBox'])) {
                throw new Error("Expected the field `carBox` to be an array in the JSON data but got " + data['carBox']);
            }
            // validate the optional field `carBox` (array)
            for (const item of data['carBox']) {
                AccountControllerDtoAccountInventoryInfoAccountInventoryCarBox.validateJSON(item);
            };
        }
        if (data['items']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['items'])) {
                throw new Error("Expected the field `items` to be an array in the JSON data but got " + data['items']);
            }
            // validate the optional field `items` (array)
            for (const item of data['items']) {
                AccountControllerDtoAccountInventoryInfoAccountInventoryItems.validateJSON(item);
            };
        }
        if (data['gears']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['gears'])) {
                throw new Error("Expected the field `gears` to be an array in the JSON data but got " + data['gears']);
            }
            // validate the optional field `gears` (array)
            for (const item of data['gears']) {
                AccountControllerDtoAccountInventoryInfoAccountInventoryGears.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
AccountControllerDtoAccountInventoryInfoResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
AccountControllerDtoAccountInventoryInfoResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
AccountControllerDtoAccountInventoryInfoResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
AccountControllerDtoAccountInventoryInfoResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
AccountControllerDtoAccountInventoryInfoResponse.prototype['contentsReward'] = undefined;

/**
 * @member {module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryWallet} wallet
 */
AccountControllerDtoAccountInventoryInfoResponse.prototype['wallet'] = undefined;

/**
 * @member {Array.<module:model/AccountControllerDtoAccountInventoryInfoAccountInventorySpecialBox>} specialBox
 */
AccountControllerDtoAccountInventoryInfoResponse.prototype['specialBox'] = undefined;

/**
 * @member {Array.<module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryCar>} car
 */
AccountControllerDtoAccountInventoryInfoResponse.prototype['car'] = undefined;

/**
 * @member {Array.<module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryCarBox>} carBox
 */
AccountControllerDtoAccountInventoryInfoResponse.prototype['carBox'] = undefined;

/**
 * @member {Array.<module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryItems>} items
 */
AccountControllerDtoAccountInventoryInfoResponse.prototype['items'] = undefined;

/**
 * @member {Array.<module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryGears>} gears
 */
AccountControllerDtoAccountInventoryInfoResponse.prototype['gears'] = undefined;






export default AccountControllerDtoAccountInventoryInfoResponse;

